import { render, staticRenderFns } from "./choosepage.vue?vue&type=template&id=71b005fc&scoped=true"
import script from "./choosepage.vue?vue&type=script&lang=js"
export * from "./choosepage.vue?vue&type=script&lang=js"
import style0 from "./choosepage.vue?vue&type=style&index=0&id=71b005fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b005fc",
  null
  
)

export default component.exports